const navigation = [
  {
    path: "/navigation/manage",
    name: "navigationManage",
    component: () => import("@/view/navigation/manage"),
  },
];
export default navigation;
